import { useRoutes } from 'react-router-dom';

import AdminRoutes from './AdminRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import MerchantRoutes from './merchantRoutes';
import { isMerchant } from 'helper/Admin';

export default function ThemeRoutes() {

  const routes = isMerchant()
    ? [MerchantRoutes]
    : [AdminRoutes, AuthenticationRoutes];

  return useRoutes(routes);
}
